export const SESSION_MAYHAVE_APPROACH_PARAMS = 1;
export const SESSION_MAYHAVE_UTCDATE_PARAM = 2;
export const SESSION_MAYHAVE_SCORING_PARAMS = 3;
